module.exports = __webpack_public_path__ + "static/callout-img.208d667f.png";


//////////////////
// WEBPACK FOOTER
// ./src/features/Products/callout-img.png
// module id = 1145
// module chunks = 259173521737895